/*
         * @ngdoc function
         * @name ePay.Model:Session_CaptchaModel
         * @description
         * Model
         */

export class Session_Captcha {
  dataDescriptor: string | null | undefined;
  dataValue: string | null | undefined;

  constructor(
    dataDescriptor?: string,
    dataValue?: string
  ) {
    this.dataDescriptor = dataDescriptor || null;
    this.dataValue = dataValue || null;
  }
}
